// utilities
import { isObject } from "wombat-global/src/utilities/object";

export function isErrorName(error: unknown, name: string): boolean {
  return isObject(error) && error.name === name;
}

function hasStringMessage(err: unknown): err is { message: string } {
  return (
    typeof err === "object" &&
    err !== null &&
    "message" in err &&
    typeof (err as { message: unknown }).message === "string"
  );
}

export function getErrorMessage(err: unknown): string {
  if (err instanceof Error) {
    return err.message;
  }

  if (hasStringMessage(err)) {
    return err.message;
  }
  return "Something went wrong";
}

export function getErrorsFromUnknown(err: unknown): unknown {
  if (Array.isArray(err)) {
    return err;
  }

  if (typeof err === "object" && err !== null && "errors" in err) {
    return (err as { errors: unknown }).errors;
  }
  return undefined;
}
